module.exports = "/static/assets/e5451eaac705d1385e4b0dbabe938e3d.png";